import { useRestartQuiz } from "./actions";

export const initialState = {
  loaded: false,
  quiz: {
    scoreToPass: 0,
  },
  progress: {
    quiz: {},
  },
  questions: {
    byId: {},
    allIds: [],
  },
}

const setProgress = (state, action) => {
  const progress = {
    ...state.progress,
    [action.payload.id]: {
      ...state.progress[action.payload.id],
      ...action.payload.data,
    }
  }

  const questions = state.questions.allIds

  let viewed = 0
  let touched = 0
  let submited = 0
  let points = 0

  questions.forEach(qId => {
    const qP = progress[qId] || {}

    if (qP.points) points += qP.points
    if (qP.viewed) viewed++
    if (qP.touched) touched++
    if (qP.submited) submited++
  })

  const quizProgress = {
    passed: points >= state.quiz.scoreToPass,
    currentScore: points,
    remainingToView: progress.quiz.totalQuestions - viewed,
    remainingToTouch: progress.quiz.totalQuestions - touched,
    remainingToSubmit: progress.quiz.totalQuestions - submited,
  }

  // TODO Refactor this garbage
  if (action.payload.id === 'quiz') {
    progress.quiz = {
      ...state.progress.quiz,
      ...action.payload.data,
      ...quizProgress,
    }
  } else {
    progress.quiz = {
      ...state.progress.quiz,
      ...quizProgress,
    }
  }

  if (typeof action.payload.callback === 'function') {
    action.payload.callback(progress)
  }

  return {
    ...state,
    progress,
  }
}

const submitQuestion = (state, action) => {
  // const question = state.questions.byId[action.payload]
  // const progress = state.progress[action.payload]
  // if (!progress) return

  // const points = progress.correct - progress.wrong === progress.target ? question.points : 0

  // console.log('test', state, action)
  // console.log('test', points)

  return {
    ...state,
    // progress: {
    //   [question.id]: {
    //     ...state.progress[question.id],
    //     submited: true,
    //     passed: points >= question.points,
    //     points: points,
    //   }
    // }
  }
}

const submitQuestions = (state, action) => {
  const newProgress = {
    ...state.progress,
  }

  state.questions.allIds.forEach(qId => {
    const question = state.questions.byId[qId]
    const progress = newProgress[qId]
    const points = progress.correct - progress.wrong === progress.target ? question.points : 0

    newProgress[qId] = {
      ...progress,
      submited: true,
      passed: points >= question.points,
      points: points,
    }
  })

  newProgress.quiz = {
    ...newProgress.quiz,
    completed: true,
  }

  if (typeof action.payload === 'function') {
    action.payload(newProgress)
  }

  return {
    ...state,
    progress: newProgress,
  }
}

const restartQuiz = (state, action) => {
  // TODO Resolve duplicate code from actions useSetDefaultProgress
  const progress = {
    quiz: {
      ...state.progress.quiz,
      passed: false,
      completed: false,
      location: 'intro',
      currentScore: 0,
      remainingToView: state.questions.allIds.length,
      remainingToTouch: state.questions.allIds.length,
      remainingToSubmit: state.questions.allIds.length,
    }
  }

  if (typeof action.payload === 'function') {
    action.payload(progress)
  }

  return {
    ...state,
    progress,
  }
}

export default (state = initialState, action) => {
  // console.log('| Dispatch:', action.type)

  switch (action.type) {
    case 'LOADED':
      return {
        ...state,
        loaded: true,
      }

    case 'SET_QUIZ':
      return {
        ...state,
        quiz: {
          ...state.quiz,
          ...action.payload,
        }
      }

    case 'SET_QUESTIONS':
      return {
        ...state,
        questions: action.payload,
      }

    case 'LOAD_PROGRESS':
      return {
        ...state,
        progress: {
          ...state.progress,
          ...action.payload,
        }
      }

    case 'SET_PROGRESS':
      return setProgress(state, action)

    case 'SUBMIT_QUESTION':
      return submitQuestion(state, action)

    case 'SUBMIT_QUESTIONS':
      return submitQuestions(state, action)

    case 'RESTART_QUIZ':
      return restartQuiz(state, action)

    default:
      return state
  }
}
